<template>
  <div class="m-edition-map-chart-node">
    <MoleculeEditionMapChartNodeHeader
      :is-node-item="true"
      :element="element"
    />
    <MoleculeContentNode/>
    <MoleculeEditionMapChartNodeTask
      v-if="$store.getters.getSelectedMapNode.path === 0 &&
        $store.getters.getSelectedMapNode.tarea"
      id="nodeTask"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartNode',

  components: {
    MoleculeContentNode: () => import('@/components/molecules/MoleculeContentNode'),
    MoleculeEditionMapChartNodeHeader: () => import('@/components/molecules/MoleculeEditionMapChartNodeHeader'),
    MoleculeEditionMapChartNodeTask: () => import('@/components/molecules/MoleculeEditionMapChartNodeTask')
  },

  props: {
    element: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
